window.addEventListener("load", ()=> {
  // fix for missing image thumbnails on product page
  function findTheVariant(data) {
    return data = data.toLowerCase().replace(" ", "").split("|")[0].split(":")[1].trim();
  }
  function activateThumbnails() {
    let activeVariantValue = document.querySelector(".main-product__media-gallery__inner-media--image[active] img");
    if (activeVariantValue) {
      activeVariantValue = findTheVariant(activeVariantValue.getAttribute("alt"));      
      const thumbnails =  document.querySelectorAll("custom-product-thumbnails .main-product-media__thumbnails li");
      
      thumbnails.forEach(item => {
        const thumbnailVariant = findTheVariant(item.getAttribute("data-media-alt"));
        
        if (thumbnailVariant === activeVariantValue) {
          item.removeAttribute("hidden", "");
          item.classList.remove("hidden");
        }
        else {
          item.classList.add("hidden");
          item.setAttribute("hidden", "");
        }
      });
    }
  }

  function selectFirstThumbnail() {
    const visibleThumbnails = document.querySelectorAll(".main-product-media__thumbnails > li:not([hidden])");
    const button = visibleThumbnails[0].querySelector("button[aria-current]");
    if (button) {
      button.click();
    }
  }
  const multiSelector = document.querySelector("multi-selector");

  if (!multiSelector) {
    activateThumbnails();
  }
  else {
    selectFirstThumbnail();
  }
  
  const mediaGallery = document.querySelector(".main-product__media-gallery__inner");
  if (!mediaGallery) return; // not a product page: nothing to observe
  const config = { attributes: true, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        if (!multiSelector) {
          activateThumbnails();
        }
        else {
          selectFirstThumbnail();
          observer.disconnect();
          observer.observe(mediaGallery, config);
        }
      }
    }
  };
  
  const observer = new MutationObserver(callback);
  observer.observe(mediaGallery, config);
});
/* ------------------------------------------------------------------
   Variant fallback for <loess-variant-picker>
   When a Pack / Length / Size combination doesn't exist (e.g. Long + S,
   Regular + 3XL), jump to the nearest existing variant instead of
   showing "Unavailable" with a stale "In stock" badge.
   - Keeps the option the customer just clicked.
   - Keeps as many of the other options as possible.
   - For the rest, picks the nearest value (S -> M, 3XL -> 2XL).
   - Ties go to the variant that's in stock.
   Patches the theme's picker at runtime: theme.js is NOT modified.
   ------------------------------------------------------------------ */
customElements.whenDefined('loess-variant-picker').then(() => {
  const Picker = customElements.get('loess-variant-picker');
  const original = Picker.prototype.updateMasterId;
  if (original.__variantFallback) return; // never patch twice

  function updateMasterIdWithFallback() {
    original.call(this);
    if (this.currentVariant) return; // valid combination: theme behaviour unchanged

    const groups = Array.from(
      this.querySelectorAll('loess-variant-radios, loess-variant-selects')
    );
    const changedIdx = groups.findIndex((g) => g.contains(this.eventTarget));
    const valueLists = groups.map((g) => {
      const select = g.querySelector('select');
      return select
        ? Array.from(select.options).map((o) => o.value)
        : Array.from(g.querySelectorAll('input')).map((i) => i.value);
    });

    let best = null;
    let bestScore = -Infinity;
    for (const v of this.getVariantData()) {
      if (changedIdx > -1 && v.options[changedIdx] !== this.options[changedIdx]) continue;
      let score = v.available ? 1 : 0;
      v.options.forEach((val, i) => {
        if (val === this.options[i]) {
          score += 1000;
        } else {
          const dist = Math.abs(
            valueLists[i].indexOf(val) - valueLists[i].indexOf(this.options[i])
          );
          score -= dist * 10;
        }
      });
      if (score > bestScore) {
        best = v;
        bestScore = score;
      }
    }
    if (!best) return; // nothing usable: fall back to the theme's "Unavailable"

    this.currentVariant = best;
    this.options = best.options.slice();
    // Sync the pills immediately (the section re-render then confirms it)
    groups.forEach((g, i) => {
      const select = g.querySelector('select');
      if (select) {
        select.value = best.options[i];
        return;
      }
      g.querySelectorAll('input').forEach((input) => {
        input.checked = input.value === best.options[i];
      });
    });
  }

  updateMasterIdWithFallback.__variantFallback = true;
  Picker.prototype.updateMasterId = updateMasterIdWithFallback;
});
/* ------------------------------------------------------------------
   Keep the current product's swatch ring in the material/colour switcher.
   Existing bug: main.js only keeps the ring when the variant has a "1x"
   option (legacy Quantity option). Products without it (Fit / Size) lose
   the ring on every variant change. This puts it back for those products
   only; products that still have a 1x/3x/… option behave as before.
   ------------------------------------------------------------------ */
(() => {
  const keepSwatchRing = () => {
    document.querySelectorAll('multi-selector').forEach((ms) => {
      ms.addEventListener('product:variant:changed', (e) => {
        const v = e.detail && e.detail.variant;
        if (!v) return;
        const hasQtyOption = [v.option1, v.option2, v.option3].some((o) =>
          /^\d+x$/i.test(o || '')
        );
        if (hasQtyOption) return; // theme logic applies
        const swatch = ms.querySelector('.product-swatch-quantity .product-swatch');
        if (swatch) swatch.classList.add('is-selected');
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', keepSwatchRing);
  } else {
    keepSwatchRing();
  }
})();

/* ------------------------------------------------------------------
   Default size per fit — product pages with the material/colour
   switcher (<multi-selector>) only.
   Regular -> M, Long -> L
   - On landing, unless the URL already names a variant (?variant=…)
   - When the customer switches Fit, unless they've already picked a
     size themselves on this page
   - Only if that size exists and is in stock for the chosen fit
   Works in EN/FR/DE: groups are found by their values, not their
   names ("Size" is "Größe" on the DE store).
   Must sit BELOW the variant-fallback block in custom.js.
   ------------------------------------------------------------------ */
(() => {
  const DEFAULT_SIZE = { Regular: 'M', Long: 'L' };
  const FIT_MARKER = 'Regular'; // a value that identifies the Fit group
  const SIZE_MARKER = 'M';      // a value that identifies the Size group

  const isMultiPage = () => !!document.querySelector('multi-selector');
  const sizeChosen = new Set(); // section ids where the customer picked a size

  const findGroups = (picker) => {
    const groups = Array.from(
      picker.querySelectorAll('loess-variant-radios, loess-variant-selects')
    );
    const values = groups.map((g) =>
      Array.from(g.querySelectorAll('input, option')).map((i) => i.value)
    );
    return {
      groups,
      fitIdx: values.findIndex((v) => v.includes(FIT_MARKER)),
      sizeIdx: values.findIndex((v) => v.includes(SIZE_MARKER)),
    };
  };

  const setGroupValue = (group, value) => {
    const select = group.querySelector('select');
    if (select) {
      select.value = value;
      return;
    }
    group.querySelectorAll('input').forEach((i) => {
      i.checked = i.value === value;
    });
  };

  // Remember real customer size clicks (capture phase = before the theme reacts)
  document.addEventListener(
    'change',
    (e) => {
      if (!e.isTrusted || !e.target.closest) return;
      const picker = e.target.closest('loess-variant-picker');
      if (!picker) return;
      const { groups, sizeIdx } = findGroups(picker);
      if (sizeIdx > -1 && groups[sizeIdx].contains(e.target)) {
        sizeChosen.add(picker.getAttribute('section-id'));
      }
    },
    true
  );

  customElements.whenDefined('loess-variant-picker').then(() => {
    const Picker = customElements.get('loess-variant-picker');
    const previous = Picker.prototype.updateMasterId;
    if (previous.__defaultSize) return; // never patch twice

    function updateMasterIdWithDefaultSize() {
      if (isMultiPage() && !sizeChosen.has(this.getAttribute('section-id'))) {
        const { groups, fitIdx, sizeIdx } = findGroups(this);
        const fitChanged =
          fitIdx > -1 && sizeIdx > -1 && groups[fitIdx].contains(this.eventTarget);
        const size = fitChanged && DEFAULT_SIZE[this.options[fitIdx]];
        if (size) {
          const opts = this.options.slice();
          opts[sizeIdx] = size;
          const variant = this.getVariantData().find((v) =>
            v.options.every((o, i) => o === opts[i])
          );
          if (variant && variant.available) {
            this.options = opts;
            setGroupValue(groups[sizeIdx], size);
          }
        }
      }
      previous.call(this); // continues into the variant fallback + theme logic
    }

    updateMasterIdWithDefaultSize.__defaultSize = true;
    Picker.prototype.updateMasterId = updateMasterIdWithDefaultSize;

    // Landing: apply the default unless the URL names a variant
    const applyOnLanding = () => {
      if (!isMultiPage() || new URLSearchParams(location.search).has('variant')) return;
      document.querySelectorAll('loess-variant-picker').forEach((picker) => {
        const { groups, fitIdx } = findGroups(picker);
        if (fitIdx < 0) return;
        const fitInput = groups[fitIdx].querySelector('input:checked');
        if (fitInput && DEFAULT_SIZE[fitInput.value]) {
          fitInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyOnLanding);
    } else {
      applyOnLanding();
    }
  });
})();